import React from "react";
import Cliente from "../../pages/cliente/Cliente";
import Clientes from "../../pages/cliente/Clientes";

const prefix = process.env.REACT_APP_PREFIX;

const clienteRoutes = [
  {
    path: `${prefix}/cliente/Cliente`,
    component: <Clientes />,
    title: "clientes",
  },
  {
    path: `${prefix}/cliente/Cliente/editar/:uid`,
    component: <Cliente />,
    title: "clientes",
  },
];

export default clienteRoutes;
